import { useQuery } from '@apollo/client'
import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import { Button, Card } from '@tecsinapse/cortex-react'
import React from 'react'
import { PiChatSlash } from 'react-icons/pi'
import { Link } from 'react-router-dom'
import { COMUNICADO_ENVIOS_RECENTES_QUERY } from '../data/comunicado-envios-recentes-query'
import {
  Comunicado,
  ComunicadoEnvioHomeCellCortex
} from './comunicado-envio-home-cell-cortex'
import { LoadingCards } from '@/core/components/loading-cards'
import { EmptyList } from '@/core/components/empty-list'

interface ComunicadoEnvioHomeBoxCortexProps {
  pathRoute: string
}

export const ComunicadoEnvioHomeBoxCortex = ({
  pathRoute
}: ComunicadoEnvioHomeBoxCortexProps) => {
  const { data, loading } = useQuery(COMUNICADO_ENVIOS_RECENTES_QUERY)
  if (loading) return <LoadingCards />
  if ((data?.comunicadoEnviosRecentes ?? []).length === 0) {
    return (
      <EmptyList
        title={t`Nada por aqui`}
        Icon={<PiChatSlash size={48} />}
        subTitle={t`Você ainda não possui comunicados.`}
      />
    )
  }
  const { comunicadoEnviosRecentes } = data
  return (
    <Card className={'flex flex-1 flex-col min-w-0'}>
      <div className={'flex justify-between items-center mb-kilo'}>
        <p className='text-h3 font-bold'>
          <Trans>Últimos comunicados</Trans>
        </p>
        <Link to={pathRoute} className={'no-underline'}>
          <Button>
            <Trans>Ver todos os comunicados</Trans>
          </Button>
        </Link>
      </div>
      {comunicadoEnviosRecentes.map((comunicado: Comunicado) => {
        return (
          <ComunicadoEnvioHomeCellCortex
            key={comunicado.comunicado.id}
            comunicadoEnvio={comunicado}
          />
        )
      })}
    </Card>
  )
}
